import { defineMessages } from "react-intl";

export const scope = "loyaltyAppHomePage";

export default defineMessages({
  rewardsLabel: {
    id: `${scope}.rewardsLabel`,
    defaultMessage: "Rewards",
  },
  homeLabel: {
    id: `${scope}.homeLabel`,
    defaultMessage: "Home",
  },
  profileLabel: {
    id: `${scope}.profileLabel`,
    defaultMessage: "Profile",
  },
  membershipLabel: {
    id: `${scope}.membershipLabel`,
    defaultMessage: "Membership",
  },
  appointmentsLabel: {
    id: `${scope}.appointmentsLabel`,
    defaultMessage: "Appointments",
  },
  exclusiveOffersLabel: {
    id: `${scope}.exclusiveOffersLabel`,
    defaultMessage: "Exclusive Offers",
  },
  yourLevelLabel: {
    id: `${scope}.yourLevelLabel`,
    defaultMessage: "Your Level",
  },
  yourActivityLabel: {
    id: `${scope}.yourActivityLabel`,
    defaultMessage: "Your Activity",
  },
  yourMembershipsLabel: {
    id: `${scope}.yourMembershipsLabel`,
    defaultMessage: "Your Memberships",
  },
  yourVouchersLabel: {
    id: `${scope}.yourVouchersLabel`,
    defaultMessage: "Your Vouchers",
  },
  doctorsLabel: {
    id: `${scope}.doctorsLabel`,
    defaultMessage: "Our Experts",
  },
  servicesLabel: {
    id: `${scope}.servicesLabel`,
    defaultMessage: "Services",
  },
  infoLabel: {
    id: `${scope}.infoLabel`,
    defaultMessage: "Information",
  },
  consentFormsLabel: {
    id: `${scope}.consentFormsLabel`,
    defaultMessage: "Consent Forms",
  },
  consentFormViewLabel: {
    id: `${scope}.consentFormViewLabel`,
    defaultMessage: "Consent Form",
  },
});
